export default {
    SetCookie: (name, value, exp) => {
        let cookieStr = `${name}=${value};`
        if (exp) {
            const date = new Date()
            date.setTime(date.getTime() + exp)
            cookieStr += `expires=${date.toUTCString()}`
        }
        document.cookie = cookieStr
    },

    GetCookie: (name) => {
        const value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
        return value ? value[2] : null
    },

    DeleteCookie: (name) => {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}